/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractorMutation } from './ContractorMutation';
import {
    ContractorMutationFromJSON,
    ContractorMutationFromJSONTyped,
    ContractorMutationToJSON,
    ContractorMutationToJSONTyped,
} from './ContractorMutation';

/**
 * 
 * @export
 * @interface ResultOfContractorMutation
 */
export interface ResultOfContractorMutation {
    /**
     * 
     * @type {ContractorMutation}
     * @memberof ResultOfContractorMutation
     */
    data: ContractorMutation | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfContractorMutation
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfContractorMutation
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfContractorMutation interface.
 */
export function instanceOfResultOfContractorMutation(value: object): value is ResultOfContractorMutation {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfContractorMutationFromJSON(json: any): ResultOfContractorMutation {
    return ResultOfContractorMutationFromJSONTyped(json, false);
}

export function ResultOfContractorMutationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfContractorMutation {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ContractorMutationFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfContractorMutationToJSON(json: any): ResultOfContractorMutation {
    return ResultOfContractorMutationToJSONTyped(json, false);
}

export function ResultOfContractorMutationToJSONTyped(value?: ResultOfContractorMutation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ContractorMutationToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

